/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "48b49409505f973786ffd77d071f6fca420b4b82";
